export default "__VITE_ASSET__BizwNvw2__"